module.exports = __webpack_public_path__ + "img/person.bad7876c.svg";